export const pages = [
  { name: 'Home', path: '/' },
  { name: 'Favorite Breweries', path: '/favorites' },
];

export const LOCAL_STORAGE_KEY = 'favoredBreweries';
